var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ThumbsUpIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 52,
    glyphHeight: 60
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M22.1015 5.52147C21.4829 5.52148 20.9119 5.84976 20.6057 6.38142L8.15509 28.0007C6.50467 30.8665 5.81207 34.175 6.17626 37.4535L7.49034 49.2829C7.72414 51.3877 9.39443 53.0548 11.5199 53.3049L19.3976 54.2319C24.598 54.8439 29.8709 54.3134 34.8404 52.6784C37.2945 51.8709 39.2603 50.0282 40.2073 47.6474L46.5484 31.7066C46.7034 31.3169 46.8106 30.9102 46.8675 30.4951C47.3484 26.9904 44.247 24.034 40.7244 24.6393L28.0139 26.8231C23.9989 27.5129 20.5311 24.0079 21.3148 20.0519L23.7908 7.55182C23.9991 6.49992 23.185 5.52146 22.1015 5.52147ZM15.7559 3.64826C17.0549 1.39274 19.4773 2.32571e-05 22.1014 3.00887e-10C26.6984 -4.08088e-05 30.1522 4.15096 29.2682 8.61354L26.7922 21.1137C26.7816 21.1672 26.7873 21.1999 26.7947 21.2234C26.8039 21.2523 26.8228 21.2862 26.8539 21.3177C26.885 21.3491 26.9188 21.3685 26.9479 21.3782C26.9715 21.3861 27.0044 21.3924 27.0588 21.3831L39.7692 19.1992C47.0111 17.955 53.3871 24.0328 52.3984 31.2378C52.2813 32.091 52.0611 32.9272 51.7423 33.7284L45.4013 49.6692C43.8486 53.5726 40.6257 56.5937 36.602 57.9176C30.8535 59.809 24.754 60.4227 18.7383 59.7148L10.8606 58.7877C6.15636 58.2342 2.45958 54.5443 1.94212 49.886L0.628047 38.0566C0.135319 33.621 1.07236 29.1448 3.30529 25.2675L15.7559 3.64826Z",
    fill: "black"
  }));
};
export var ThumbsUpIconGlyph = function (props) {
  return React.createElement(ThumbsUpIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};